import selectors from "./selectors";

export default { selectors };
